import { html } from "lit";
import { renderStandardPictureElement } from "../../../../utils";
import {
    exampleProductParts,
    ProductDetailTabHeader,
    ProductPartType,
} from "./shared";

const items: ProductPartType[] = exampleProductParts.slice(0, 5);

const renderTile = (item: ProductPartType) => html`
    <!-- Tile -->
    <div class="ux-col-12 ux-col-md-6 ux-u-margin-bottom-30">
        <div class="block u-shadow" data-same-height="item">
            <div class="block-image">
                ${renderStandardPictureElement({
                    width: 1700,
                    height: 800,
                })}
            </div>
            <div class="ux-u-p-xxs">
                <div
                    class="ux-text-title ux-text-title--bold ux-text-title--green-square ux-u-mb-xxxs"
                >
                    ${item.title}
                </div>
                ${item.sizes.map(
                    (size) => html`
                        <div class="ux-text-normal--light-grey">
                            ${size.size}&nbsp;${size.number}
                        </div>
                    `
                )}
            </div>
        </div>
    </div>
`;

export const ProductParts2Template = () => html`
    <!-- Product Parts 2 Columns -->
    <div class="ux-t-container">
        <ux-iws-same-height>
            <div class="ux-row">
                <!-- BEGIN Loop -->
                ${items.map(renderTile)}
                <!-- END Loop -->
            </div>
        </ux-iws-same-height>
    </div>
`;

export const TabDeliveryscope = () => html`
    <div id="tabDeliveryscope">
        ${ProductDetailTabHeader({
            description: `Die nachfolgenden Verbrauchsmaterialien und das
                entsprechende Zubehör sind im Lieferumfang mit enthalten.`,
        })}
        ${ProductParts2Template()}
    </div>
`;
